import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { Grid, Row, Col, Button, FormControl, ControlLabel, FormGroup } from "react-bootstrap"

import "./styles.css"
import FieldGroup from "../FieldGroup"
import { email, requiredValue } from "dck-validators"
import { initField } from "../../lib/form-builder"
import { DckSelectors, DckActionCreators, DckActionTypes } from "dck-redux"

import Spinner from "react-spinkit"
import FontAwesome from "react-fontawesome"
import Legal from "../fragments/Legal"
import { validateVerifCode, resetVerifCode } from "../../redux/actions/account"
import * as ItemTypes from "../../redux/items/types"

import store from "store"
import { blockingFetchServiceNoToken } from "../../lib/blockingFetch"
import authServerApi from "../../redux/sagas/authServerApi"
import { maskEmail } from "../../lib/utils"

class SignIn extends Component {

  SIXTY_SECONDS = 60

  constructor(props) {

    super(props)

    const userInfo = store.get('userInfo'),
    tempoSessionData = store.get('tempoSessionData'),
    display2FA = userInfo && userInfo.mustVerify2FA === true
      && tempoSessionData && tempoSessionData.access_token ? true : false

    this.state = {

      ...initField(this, 'email', '', email),
      ...initField(this, 'password', '', requiredValue),

      showPassword: false,
      verificationCode: '',
      display2FA: display2FA,
      error: null,
      emailCode: userInfo ? userInfo.username : null,
      resendText: false,
      retryIn: this.SIXTY_SECONDS,
      successResend: false,
      runningResend: false,
    }

    this.inputRef = null 
    this.setInputRef = elt => {
      this.inputRef = elt
    }
  }

  valid = () => {
    const { email, password } = this.state
    return !!(
      email.validation &&
      email.validation.valid &&
      password.validation &&
      password.validation.valid
    )
  }

  signInClick = () => {
    if(this.valid()) {
      const { email, password } = this.state
      this.setState({ emailCode: email.value, error: null })
      this.props.signIn(email.value, password.value)
      this.stopTimerResendCode()
      this.startTimerResendCode()
    }
    else {
      this.setState({error: 'Please enter a valid email and password!'})
    }
  }

  componentDidMount() {
    if(this.state.display2FA) {
      this.startTimerResendCode()
    }
    else {
      this.props.asyncProcessReset(DckActionTypes.SIGN_IN)
    }
  }

  componentWillUnmount() {
    this.stopTimerResendCode()
  }

  startTimerResendCode = () => {

    this.setState({resendText: false, retryIn: this.SIXTY_SECONDS})

    this.timeoutResendCodeId = setInterval(() => {

      const { retryIn } = this.state
      if(retryIn === 0) {
        this.setState({resendText: true})
        this.stopTimerResendCode()
      }
      else {
        this.setState({retryIn: retryIn - 1})
      }
    }, 1000)
  }

  stopTimerResendCode = () => clearInterval(this.timeoutResendCodeId)

  validateVerificationCode = () => {
    const { verificationCode } = this.state,
    regexp = new RegExp("^(?=.*[0-9])(?=\\S+$).{6}$")
    return verificationCode === '' ? null : (regexp.test(verificationCode) ? 'success' : 'error')
  }

  verifCodeChanged = verificationCode => this.setState({ verificationCode })

  processVerify2FA = () => {
    if(this.validateVerificationCode() === 'success') {
      this.setState({ error: null })
      this.props.validateVerifCode(this.state.verificationCode)
    }
    else {
      this.setState({ error: 'Please enter a 6-digit code!' })
    }
  }

  backToSignIn = () => {
    const { asyncProcessReset, resetVerifCode } = this.props
    asyncProcessReset(DckActionTypes.SIGN_IN)
    resetVerifCode()
    this.setState({ display2FA: false, error: null })
    this.stopTimerResendCode()
  }

  resendVerifCode = () => {

    this.setState({ runningResend: true, successResend: false, error: null })
    const tempoSessionData = store.get('tempoSessionData'),
    accessToken = tempoSessionData ? tempoSessionData.access_token : null

    blockingFetchServiceNoToken(
      _ => authServerApi.send2FACode(accessToken), 
      _ => {
        this.setState({ successResend: true })
        this.startTimerResendCode()
      },
      error => {
        this.setState({ error: error.text })
      },
      _ => {
        this.setState({ runningResend: false })
      }
    )
  }

  handleKeyDown = event => {
    if(event.key === 'Enter') {
      this.signInClick()
    }
  }

  handle2FAKeyDown = event => {
    if(event.key === 'Enter') {
      this.processVerify2FA()
    }
  }

  toggleShowPassword = () => {
    if (this.inputRef.focus) {
      this.inputRef.focus()
    }
    this.setState({ showPassword: !this.state.showPassword })
  }

  renderSignInForm() {

    const { signInProcessFailed, errorResult, signInProcessRunning } = this.props,
    { email, password, showPassword, error } = this.state
    return (
      <div>

        <h2 className="title-login">
          <FontAwesome name='user' size="lg"/> Sign In
        </h2>

        <form className="signin-form">

          <FieldGroup
            id="email"
            type="email"
            label="Email address"
            placeholder="Enter email"
            value={ email.value }
            onChange={ email.onChange }
            validationState={ email.validation }
            validationMessage="Please enter a valid email"
            onKeyDown={ this.handleKeyDown }
            autoFocus
          />

          <div className="relative">
            <FieldGroup
              id="password-login"
              label="Password"
              type={ showPassword ? 'text' : 'password' }
              placeholder="Enter password"
              value={ password.value }
              onChange={ password.onChange }
              validationState={ password.validation }
              minLength={8}
              maxLength={20}
              validationMessage="Please enter password"
              onKeyDown={ this.handleKeyDown }
              inputRef={ this.setInputRef }
              className="pr-16"
            />

            <div id="show-password-login" onClick={ this.toggleShowPassword }>
              { showPassword ? 'Hide' : 'Show' }{ ' '}
              <FontAwesome name={ showPassword ? 'eye-slash' : 'eye' } />
            </div>
          </div>

          <div className="text-center sign-in-button-container">

            { signInProcessFailed && <div className="errorText"><strong>{ errorResult }</strong></div> }

            { error && <div className="errorText"><strong>{ error }</strong> </div> }

            { signInProcessRunning && <Spinner name="double-bounce" color="white" /> }

            <Button
              bsStyle="primary"
              disabled={ signInProcessRunning }
              onClick={ this.signInClick }>
              <FontAwesome name='sign-in' size="lg"/> Login
            </Button>

          </div>
        </form>
      </div>
    )
  }

  render2FA = () => {

    const { send2FARunning, send2FAFailed, send2FAResultText } = this.props,
    { runningResend, emailCode, verificationCode, resendText, retryIn, error } = this.state

    return (
      <div>

        <div>
          <FontAwesome
            onClick={ this.backToSignIn }
            name='arrow-circle-left' size="2x" 
            className='verif-arrow-circle-left cursor-pointer'
            title='Back' />
          <h3 className="title-login">2-step verification</h3>
        </div>

        <form className="signin-form">

          <FormGroup controlId="verificationCode" validationState={ this.validateVerificationCode() }>

            <p className="verif-text-msg">
              { runningResend 
                ? <span>Sending an email to { maskEmail(emailCode) } ..</span>
                : <span>An email with a verification code was just sent to 
                  &nbsp;<strong>{ maskEmail(emailCode) }</strong></span>
              }
            </p>

            <ControlLabel>Enter your verification code</ControlLabel>

            <FormControl type="number" placeholder="Enter the 6-digit code"
              value={ verificationCode }
              min='1'
              onChange={e => this.verifCodeChanged(e.target.value)}
              disabled={ send2FARunning }
              onKeyDown={ this.handle2FAKeyDown }
              autoFocus
            />
            <FormControl.Feedback />

          </FormGroup>

          <div className="text-center sign-in-button-container">

            { send2FAFailed &&
              <div className="errorText">
                <strong>{ send2FAResultText }</strong>
              </div>
            }

            { error &&
              <div className="errorText">
                <strong>{ error }</strong>
              </div>
            }

            { send2FARunning &&  <Spinner name="double-bounce" color="white" /> }

            <Button
              bsStyle="primary"
              disabled={ send2FARunning }
              onClick={ this.processVerify2FA }>
              Verify
            </Button>

          </div>

          <p className='resend'>
            Didn't receive the code?&nbsp;
            { runningResend || send2FARunning
            ? <span>Waiting..</span>
            : resendText
              ? <span onClick={() => this.resendVerifCode() } className='resend-action cursor-pointer'>
                Click to resend</span>
              : <span>Resend in { retryIn }s</span>
            }
          </p>

        </form>
      </div>
    )
  }

  render() {

    const { process2FA } = this.props,
    { display2FA } = this.state

    return (
      <Grid bsClass="signin-container container-fluid">

        <Row bsClass="signin-content row">

          <Col md={6} id="col1" className="vcenter">
            <img className="w-80p sm:w-300"
              src={ require("../../files/logo.png") }
              alt="Logo"
            />
            <h1 className="welcome text-3xl sm:text-4xl">Onboarding Admin UI</h1>
            <Legal />
          </Col>

          <Col md={6} id="col2" className="vcenter">
            <div className="signin-form-container">
              { display2FA || process2FA ? this.render2FA() : this.renderSignInForm() }
            </div>
          </Col>

        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = state => {

  const mapping = {

    signInProcessRunning: DckSelectors.selectProcessRunning(
      state,
      DckActionTypes.SIGN_IN
    ),

    signInProcessFailed: DckSelectors.selectProcessFailed(
      state,
      DckActionTypes.SIGN_IN
    ),

    processResult: DckSelectors.selectProcess(
      state,
      DckActionTypes.SIGN_IN
    ),

    process2FA: DckSelectors.selectProcessRunning(
      state,
      ItemTypes.VerifCode
    ),

    send2FARunning: DckSelectors.selectProcessRunning(
      state,
      ItemTypes.Send2FA
    ),

    send2FAFailed: DckSelectors.selectProcessFailed(
      state,
      ItemTypes.Send2FA
    ),

    send2FAResult: DckSelectors.selectProcess(
      state,
      ItemTypes.Send2FA
    ),

    errorResult: null,
    send2FAResultText: null,
  }

  mapping.errorResult = (mapping.processResult && mapping.processResult.result && mapping.processResult.result.text) 
    ? mapping.processResult.result.text : mapping.signInProcessFailed ? 'An error occurred!' : null

  mapping.send2FAResultText = (mapping.send2FAResult && mapping.send2FAResult.result && mapping.send2FAResult.result.text) 
    ? mapping.send2FAResult.result.text : mapping.send2FAFailed ? 'An error occurred!' : null

  return mapping
},

mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(DckActionCreators, dispatch),
    validateVerifCode: code => dispatch(validateVerifCode(code)),
    resetVerifCode: () => dispatch(resetVerifCode()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn)



// WEBPACK FOOTER //
// ./src/components/SignIn/index.js